/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react'
import './index.scss'
import NavBar from '../../../components/navbar'

const tasks = [
  {
    taskDescription: 'Portfolio',
    team: 'Myself',
    workYouDid: [
      'Build a portfolio for myself',
      'Write blogs, about the things that I have done and learned doing esp while coding'
    ],
    tools: ['React', 'Gatsby'],
    whatILearnt: [
      `To use the information that I had about coding to practicle use`,
      'Learned more about gatsby js',
      'App deployment to now.sh'
    ],
    website: 'https://portfolio.aditya2.now.sh'
  }
]

export const Rens = () => {
  return (
    <>
      <NavBar />
      <div className="rens">
        {tasks.map(task => (
          <div key={task} className="rens__work">
            <span>Task:</span>
            <p className="work__desc">{task.taskDescription}</p>
            <span>Team:</span>
            <p className="work__team">{task.team}</p>
            <span>What I did?</span>
            <ul className="work__you-did">
              {task.workYouDid.map(work => (
                <li key={work}> ==> {work}</li>
              ))}
            </ul>
            <span>What I learnt</span>
            <ul className="lessons">
              {task.whatILearnt.map(lesson => (
                <li key={lesson}>==> {lesson}</li>
              ))}
            </ul>
            <span>Tools Used</span>
            <ul className="tools__used">
              {task.tools.map(tool => (
                <li key={tool}>{tool}</li>
              ))}
            </ul>
            <span>Result:</span>{' '}
            <p>
              <a href={task.website} target="__blank">
                Aditya Gyawali's Portfolio
              </a>
            </p>
          </div>
        ))}
      </div>
    </>
  )
}
export default Rens
